/* @flow */

import * as React from 'react';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './NotificationPortal.style';
import { notificationElevation } from 'src/shared/app/base/style/token/elevation';

import { portalNotificationId } from 'src/shared/app/base/constant/domConstants';
import Fixed from 'src/shared/app/base/component/fixed/Fixed';
import Container from 'src/shared/app/base/component/container/Container';
import usePortalRegistrationLength from 'src/shared/app/base/portal/notification/hook/usePortalRegistrationLength';

const useStyles = createUseThemeStyles(styles);

const NotificationPortal = (): React.Node => {
  const ref = React.useRef();
  const [show, setshow]: Object = React.useState<boolean>(false);
  const classes = useStyles({ show });

  const elementsLength = usePortalRegistrationLength(portalNotificationId);

  React.useEffect(() => {
    setshow(elementsLength > 0);
  }, [elementsLength]);

  return (
    <Fixed fullWidth zIndex={notificationElevation} show={show}>
      <div className={classes.root}>
        <div className={classes.overlay} />
        {/* $FlowIssue */}
        <Container>
          <div id={portalNotificationId} ref={ref} />
        </Container>
      </div>
    </Fixed>
  );
};

export default React.memo<{}>(NotificationPortal);
